import NotSpammingAgency from './NotSpammingAgency';

export default NotSpammingAgency;
